/* All intellectual property rights in the software, code and associated materials ("Software") belong to Leo Learning Limited and its licensors. All rights in the Software are expressly reserved by and to Leo Learning Limited and its licensors. Without limiting the generality of the foregoing, users of the Software are not permitted to (and agree not to) reproduce, copy or otherwise duplicate, and not to distribute, lend or otherwise transfer the Software or any part of it without the express written permission of Leo Learning Limited. Each user also undertakes not to use the Software in any way that would compromise the confidential and proprietary nature of the Software. Each user undertakes to use the Software only in accordance with the terms of the respective user license and not to resell, reproduce, sell, modify the Software in any way and acknowledges that it has no permission to so do. */ // eslint-disable-line max-len
/* global gettext */
import React, { Component } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import { List } from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { hasSucceeded } from 'consts/requestStates';
import LiveButton from 'components/form/LiveButton';
import FormError from 'components/form/FormError';
import FieldWithError from 'components/form/FieldWithError';


export const ResetPasswordForm = ({ handleSubmit, requestState }) => (
  <form onSubmit={handleSubmit}>
    <p className="small-text">
      {gettext('Enter your new password below:')}
    </p>

    <FormError name="non_field_errors" requestState={requestState} />
    {requestState && (requestState.getIn(['data', 'uid']) || requestState.getIn(['data', 'token'])) && (
      <p className="error">{gettext('This URL does not appear to be valid.')}</p>
    )}

    <label htmlFor="password">{gettext('Password')}</label>
    <FormError name="password" requestState={requestState} />
    <Field
      name="password"
      component={FieldWithError}
      innerComponent="input"
      type="password"
    />

    <label htmlFor="confirmPassword">{gettext('Confirm Password')}</label>
    <Field
      name="confirmPassword"
      component={FieldWithError}
      innerComponent="input"
      type="password"
    />

    <LiveButton
      className="btn-default"
      requestState={requestState}
      pendingMessage={gettext('Resetting password...')}
      getAdditionalErrors={responseData => responseData.getIn(['errors', 'uid'], List())}
    >
      {gettext('Reset Password')}
    </LiveButton>

    {hasSucceeded(requestState) && (
      <p className="small-text alert-success">
        {gettext('Password has been reset. Now login with your new password.')}<br />
        <Link to="/login/" className="underlined">Log in</Link>
      </p>
    )}
  </form>
);
ResetPasswordForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  requestState: ImmutablePropTypes.map,
};
ResetPasswordForm.defaultProps = {
  requestState: null,
};

export function validate(data) {
  if (data.password === '') {
    return { password: 'Password must not be empty' };
  } else if (data.confirmPassword !== data.password) {
    return { confirmPassword: 'Passwords must match' };
  }
  return {};
}

export default reduxForm({
  form: 'resetPassword',
  validate,
})(ResetPasswordForm);
